import React from "react";
import ReactDOM from "react-dom";
import Route from "./routes";

ReactDOM.render(
  <React.StrictMode>
    <Route />
  </React.StrictMode>,
  document.getElementById("root")
);
